(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["khapia-eventos"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('.khapia-event-card__sound');
    if (!button) return;
    const media = button.closest('.khapia-event-card__media');
    const video = media?.querySelector('.khapia-event-card__video');
    if (!video) return;
    video.muted = !video.muted;
    button.setAttribute('aria-pressed', String(!video.muted));
    if (video.paused) video.play().catch(function() {});
  });

  } catch(e) { console.error(e); }
})();
})();
